import { Component, Input } from '@angular/core';
import { FiltersService } from 'src/app/core/services/filters.service';
import { ContractModel } from 'src/app/global/contract-filter-model';
import { TvdDrillInMetricTiles } from '../../types/tvd-types';
import { Division } from 'src/app/core/services/ebr-api-client/ebr-api-client.g';
import { TvdKpiCardBuilder } from '../../builders/tvd-kpi-card-builder';


@Component({
    selector: 'app-tvd-kpi-grid',
    templateUrl: './tvd-kpi-grid.component.html',
    styleUrls: ['./tvd-kpi-grid.component.scss'],
    standalone: false
})
export class TvdKpiGridComponent {
  @Input() metrics: TvdDrillInMetricTiles[] = [];
  @Input() currencySymbol: string = '';
  filters: ContractModel | undefined;
  isPestView: boolean = false;


    constructor(
      private _filterService: FiltersService,
      private _tvdKpiCardBuilder: TvdKpiCardBuilder,
    ) {
    }
  ngOnInit() {
    this._filterService.selectedFiltersObservable.subscribe(
      (f) => {
        this.filters = f;
        this.isPestView = this.filters?.division === Division.Pest;
      }
    );
  }

  shouldShowDefault(metric: TvdDrillInMetricTiles): boolean {
    return this._tvdKpiCardBuilder.shouldShowDefaultValueForKpiCard(metric);
  }
}
